// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:46:37+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            2e0182c4cf49ce7272a9e0af83ec6981
//    Signature:      eyJpdiI6ImRMRVI2MFNaSG15akdmejc5NHVXbUE9PSIsInZhbHVlIjoiMVNRdFQrYlpKYzNSXC9QMVVJZUJqRnh3M0ZpUXFLdzJoaXE2MXIzaDdrZWtcL0tUVzkwdW9GQ0FtalFXUDdxMDZJSlFnU1NvTU54YzFGY0IwRU1KVmhhYmRqMkc0aHRsSkg0dVIwSE5GNGplVlN5UXRzeFVoOXFuWWs0WVNlRmtFbWtXSW1cLzZ6aGFnbkJYQmNQMlwvMkJpbVBPWWtGNXI1V0pDU204WWhGRGlHWFV2VUpNUVwvb0dyNFNhMmRhXC9RVVwvRHY1MjRqRjVzSWFYWEFZeHNjTjJrVEVjZWJTK1VwNVhNM0taOWNhZXhvU2NPVXhLNEtqYWJvdHNUSURueHF5UWdxTlBNMWdjU0RianRPSk1YOVNjd3U0V1wvNG5ER0dxbkcwNXdKRmV6RnJ4d3FTXC9OUkdmbUI0aGN0QVJCNHF0c1wvZFZpUDdBUGdiOVdWN2NzWjlIMVpGeDdcL0hiNFJtMWxla1Q4VHJSaW1LcndaUDBcL3dzdzdSUVNqdWF2T1djaEFPaW13UGVqQnlmTmpmRllGbkJybnVLMW9sZmlUb1R1MllISHdTUysyT2pxND0iLCJtYWMiOiIxZGRhMGIxMmIwYjIzYWQ2NmYzNDZmMTY3MDJlNzlkOGE2OTIwY2I0MGYyY2Y3MzZlNWMxOTFlNjJmOWQzY2Q4In0=
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
